import React from 'react';
import { Box, Button } from '@mui/material';

// BE #874: clickable answers to a clarification. The backend sends only options it can
// execute; one click sends the option's `value` as the next message, so nothing is retyped.
export default function ChatClarificationOptions({ options = [], disabled = false, onSelect }) {
  const visible = Array.isArray(options) ? options : [];
  if (visible.length === 0) return null;

  return (
    <Box
      role="group"
      aria-label="Suggested answers"
      data-testid="chat-clarification-options"
      sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.5, maxWidth: '100%' }}
    >
      {visible.map((option) => (
        <Button
          key={option.value}
          variant="outlined"
          size="small"
          disabled={disabled}
          onClick={() => onSelect?.(option.value)}
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            maxWidth: '100%',
            justifyContent: 'flex-start',
            textAlign: 'left',
            whiteSpace: 'normal',
          }}
        >
          {option.label}
        </Button>
      ))}
    </Box>
  );
}
